// extracted by mini-css-extract-plugin
export default {"container":"Detailes_container__oxaYh","collapse":"Detailes_collapse__xph3V","details":"Detailes_details__oJ-yy"};